<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M10.875 10.875a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 23.25V18.7c2.687-.3 6.75-2.258 6.75-8.2a1.5 1.5 0 0 0-3 0c0 4.932-3.754 5.238-4.51 5.25H9a3 3 0 1 0 0 6h3a1.5 1.5 0 0 0 0-3H9M10.5 21.75v1.5M.75.75h1.5l1.402 1.402"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M4.273 5.774A.74.74 0 0 1 3.1 5.632 3 3 0 0 1 7.134 1.6a.739.739 0 0 1 .141 1.173L4.273 5.774Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m8.575 4.68 1.116.62M10.372 2.379l1.615.44M14.59 3.529l1.615.441M6.353 7.024l.577 1.038M4.008 8.743l.44 1.615M5.158 12.961l.245.896"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
